/* eslint-disable import/prefer-default-export */
export enum CHANNEL {
  VOICE = 'VOICE',
  SMS = 'SMS',
}
